import {OverlayPanel} from "primereact/overlaypanel";
import type {RefObject} from "react";

import {type AppreciationKey, getAppreciationId} from "../../redux/appreciationsUtil";
import AppreciationInputText from "./AppreciationInputText";
import {resolveAppreciationId} from "./appreciationHooks";

interface AppreciationOverlayProps {
    /** option1: provide appreciation key */
    appreciationKey?: AppreciationKey;
    /** option2: provide appreciation page (and tab and section), to calculate key */
    page?: string;
    tab?: string;
    section?: string;
    /** Displayed placeholder */
    placeholder?: string;
    /** reference to the overlay */
    ref: RefObject<OverlayPanel | null>;
    /** overlay onHide */
    onHide?: () => void;
    /** overlay onShow */
    onShow?: () => void;
    /** CSS-Breite des Panels (Standard 50vw) */
    width?: string;
    /** Pfeil am rechten Rand (über dem Symbol) statt über dem Anker */
    arrowAtRight?: boolean;
}

/**
 * Wrapper for AppreciationInputText, in an overlay.
 */
export default function AppreciationOverlay({
    appreciationKey,
    page,
    tab,
    section,
    placeholder,
    ref,
    onHide,
    onShow,
    width = "50vw",
    arrowAtRight = false,
}: AppreciationOverlayProps) {
    const effectiveAppreciationKey = resolveAppreciationId(appreciationKey, page, tab, section);
    const appreciationId = getAppreciationId(effectiveAppreciationKey);

    return (
        <OverlayPanel
            id={`appreciationOverlay_${appreciationId}`}
            ref={ref}
            className={`bg-surface-100 dark:bg-surface-700 ${arrowAtRight ? "appreciation-overlay-arrow-right" : ""}`}
            style={{width}}
            onShow={onShow}
            onHide={onHide}
        >
            <div>
                <AppreciationInputText
                    appreciationKey={appreciationKey}
                    page={page}
                    tab={tab}
                    section={section}
                    autoFocus={false}
                    placeholder={placeholder}
                />
            </div>
        </OverlayPanel>
    );
}
